import { createContext, useState } from "react";

export const UserContext = createContext({
    currentUser:null,
    setCurrentUser:()=>null,
});

export const UserProvider = ({children})=>{
    const [currentUser,setCurrentUser] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem('userK2G')) || null;
        } catch {
            localStorage.removeItem('userK2G');
            return null;
        }
    });
    const value = {currentUser,setCurrentUser};

    return <UserContext.Provider value={value}>{children}</UserContext.Provider>
}